import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import walteroTheme from '../../theme/walteroTheme';

/**
 * WalteroThemeProvider - Central theme management component
 * 
 * Provides the complete Waltero brand theme to all child components.
 * Includes CssBaseline for consistent baseline styles and font loading.
 * 
 * @param {Object} props - Component properties
 * @param {React.ReactNode} props.children - Child components to receive theme
 * @param {Object} [props.theme] - Optional theme override (defaults to walteroTheme)
 */
const WalteroThemeProvider = ({ 
  children, 
  theme = walteroTheme 
}) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default WalteroThemeProvider;